// Mapeamento puramente visual de estados de Ordem de Serviço.
// Os valores das chaves correspondem ao que vem do backend e NÃO devem ser alterados;
// apenas os rótulos e as cores apresentados ao utilizador são definidos aqui.

// Algumas OS têm status "Em Execução" no DB (forma display) em vez de "execução"
// (forma canónica). Este mapa normaliza para a forma canónica antes de qualquer lookup.
const STATUS_CANONICAL = {
  "em execução": "execução",
};

export function normalizeOrdemServicoStatus(status) {
  if (status === null || status === undefined) return status;
  const key = String(status).toLowerCase();
  return STATUS_CANONICAL[key] || status;
}

export const ORDEM_SERVICO_STATUS_LABELS = {
  ativo: "Pendente",
  atribuido: "Pré-Alocado",
  confirmado: "Alocado",
  agendado: "Agendado",
  "execução": "Em Execução",
  transferido: "Transferido",
  interrompido: "Interrompido",
  remarcar: "A Remarcar",
  fechado: "Fechado",
  cancelado: "Cancelado",
  falta: "Falta",
};

export function getOrdemServicoStatusLabel(status) {
  if (status === null || status === undefined) return "";
  const canonical = normalizeOrdemServicoStatus(status);
  const key = String(canonical).toLowerCase();
  return ORDEM_SERVICO_STATUS_LABELS[key] || status;
}

export const ORDEM_SERVICO_STATUS_COLORS = {
  ativo: "text-yellow-400",
  atribuido: "text-yellow-300",
  confirmado: "text-blue-300",
  agendado: "text-blue-400",
  "execução": "text-blue-500",
  transferido: "text-purple-400",
  interrompido: "text-orange-400",
  remarcar: "text-orange-400",
  fechado: "text-green-400",
  cancelado: "text-red-400",
  falta: "text-red-400",
};

export function getOrdemServicoStatusClass(status) {
  if (!status) return "text-gray-400";
  const canonical = normalizeOrdemServicoStatus(status);
  const key = String(canonical).toLowerCase();
  return ORDEM_SERVICO_STATUS_COLORS[key] || "text-gray-400";
}

// Badge background+text colors keyed by the MAPPED label (lowercase).
// Used with GenericDataTable2 badgeClass after computed() transforms the raw status.
export const ORDEM_SERVICO_BADGE_COLORS = {
  "pendente":    "bg-yellow-500/20 text-yellow-300",
  "pré-alocado": "bg-purple-500/20 text-purple-300",
  "alocado":     "bg-blue-400/20 text-blue-300",
  "agendado":    "bg-yellow-500/20 text-yellow-300",
  "em execução": "bg-green-600/20 text-green-300",
  "transferido": "bg-yellow-600/20 text-yellow-200",
  "interrompido":"bg-orange-600/20 text-orange-200",
  "a remarcar":  "bg-red-500/20 text-red-300",
  "fechado":     "bg-green-600/20 text-green-300",
  "cancelado":   "bg-gray-500/20 text-gray-300",
  "falta":       "bg-red-500/20 text-red-300",
};

export function getOrdemServicoStatusBadgeClass(mappedLabel) {
  if (!mappedLabel) return "bg-gray-400/20 text-gray-300";
  const key = String(mappedLabel).toLowerCase();
  return ORDEM_SERVICO_BADGE_COLORS[key] || "bg-gray-400/20 text-gray-300";
}

// Estados que definem a etapa de Execução nas páginas de Negócios, pela ordem
// em que aparecem no filtro. Os rótulos vêm do mapa geral acima.
export const OS_STATUS_EXECUCAO = ["atribuido", "confirmado", "fechado"];
